module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode cadastrar todas as conclusões técnicas. Essas conclusões podem ser vinculados no cadastro do LTCAT."
    }
  }), _vm._v(" "), _c('Conclusao')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-modelo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Ocultar Items no Documento\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode ocultar ou exibir os items no modelo do LTCAT criado."
    }
  }), _vm._v(" "), _c('Modelo')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2e1be3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/configuracao/index.vue
// module id = 1488
// module chunks = 45